import React from "react";
import SearchFilter from "components/searchFilter";
import useTranslation from "utils/hooks/useTranslation";

interface IPropsSearchFilterTags {
  tagsUpdateFilter: (...args) => void;
  tagsChangeFieldValue: (...args) => void;
}

const TagsFilter = ({ tagsUpdateFilter, tagsChangeFieldValue }: IPropsSearchFilterTags) => {
  const SEARCH_PLACEHOLDER = `${useTranslation({
    id: "search_for_tag_number_or_license_plate",
  })}...`;

  return <SearchFilter placeholder={SEARCH_PLACEHOLDER} updateFilter={tagsUpdateFilter} changeFieldValue={tagsChangeFieldValue} numbersTypedCharacters={3} />;
};

export default TagsFilter;
